import { Params } from "../../api/commercial/url/params";
import { ProductRefType } from "./types";

const productRefToProduct = (productRef: string): ProductRefType | null => {
  const isProductRefValid =
    Object.values(ProductRefType).find(
      (productRefTypeValue) => productRefTypeValue === productRef,
    ) !== undefined;

  return isProductRefValid ? (productRef as ProductRefType) : null;
};

/**
 * This function takes the product reference from the URL and returns it in @type {ProductRefType} format.
 */
const getProductRefFromUrl = (): ProductRefType | undefined => {
  return productRefToProduct(Params.productRef.get());
};

const ProductContextHelper = {
  productRefToProduct,
  getProductRefFromUrl,
};

export default ProductContextHelper;
